import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import professionalismIcon from '../../assets/images/professionalism-icon.png';
import teacherIcon from '../../assets/images/teacher-icon.png';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../store/slices/cartSlice';

const CourseCard = ({ 
  id = 1,
  title = "العلوم الإدارية", 
  instructor,
  category = "الدورات",
  originalPrice = "399 ريال",
  discountedPrice = "299 ريال",
  isSubscribed = false,
  isExpired = false, // إضافة خاصية جديدة للدورات المنتهية
  is_coming_soon_display = false, // إضافة خاصية جديدة للدورات القادمة قريبًا
  discount = "25%",
  startDate = "10 يناير",
  endDate = "10 مارس",
  coursePlan = "/course-plan.jpg",
  coverImage = "https://picsum.photos/id/1018/1920/1080", // صورة غلاف الدورة - المقاس المطلوب 1920x1080
  price = 399
}) => {
  const dispatch = useDispatch();
  const [showPlan, setShowPlan] = useState(false);
  const [coverLoaded, setCoverLoaded] = useState(false);

  return (
    <div className="block border border-gray-200 dark:border-gray-700 rounded-lg">
      {/* مودال عرض خطة الدورة - خارج الرابط عشان ما يدخلش جوة الدورة */}
      {showPlan && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowPlan(false);
          }}
        >
          <div className="relative max-w-3xl mx-4" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowPlan(false);
              }}
              className="absolute top-2 left-2 text-white bg-black bg-opacity-50 rounded-full p-1 hover:bg-opacity-75 focus:outline-none"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={coursePlan} 
              alt="خطة الدورة" 
              className="w-full max-h-[75vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()} 
            />
          </div>
        </div>
      )}

      <Link to={`/courses/${id}`} className="block">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col h-full">
          {/* Course Cover Image Container */}
          {/* صورة غلاف الدورة - يجب أن تكون بمقاس 1920x1080 للجودة المثالية */}
          <div className="relative w-full h-[220px]">
            {!coverLoaded && (
              <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 animate-pulse rounded-lg"></div>
            )}
            <img 
              src={coverImage}
              alt={title}
              className={`w-full h-full object-cover rounded-lg ${coverLoaded ? '' : 'invisible'}`}
              loading="lazy"
              width="400"
              height="220"
              onLoad={() => setCoverLoaded(true)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://placehold.co/400x220?text=صورة';
              }}
            />
            
            {/* Tags Container */}
            <div className="absolute top-3 right-3">
              {/* Category Tag */}
              <div className="bg-[#0056b3] dark:bg-[#0056b3] px-3 py-1 rounded-lg text-white dark:text-white">
                <span className="text-xs font-medium">
                  {category}
                </span>
              </div>
            </div>

            <div className="absolute top-3 left-3">
              {/* Discount Tag */}
              {discount && (
                <div className="bg-red-500 dark:bg-red-500 px-3 py-1 rounded-lg">
                  <span className="text-xs font-medium text-white dark:text-white">
                    خصم {discount}
                  </span>
                </div>
              )}
            </div>
            
            {/* Gradient Overlay */}
            <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-black/20 to-transparent dark:from-black/20 dark:to-transparent"></div>
          </div>

          <div className="p-5 flex flex-col gap-5">
            {/* Course Title */}
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white line-clamp-2">
              {title}
            </h2>

            {/* Course Plan Section */}
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm text-gray-600 dark:text-gray-300">
                {startDate}
              </span>
              <button 
                onClick={(e) => {
                  e.preventDefault(); // منع الانتقال للدورة
                  e.stopPropagation(); // منع انتشار الحدث
                  setShowPlan(true); // فتح المودال
                }} 
                className="flex-1 text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 px-4 py-2 rounded-full text-sm font-medium hover:bg-gray-100 dark:hover:bg-gray-600"
              >
                <span className="font-semibold">خطة الدورة</span>
              </button>
              <span className="text-sm text-gray-600 dark:text-gray-300">
                {endDate}
              </span>
            </div>

            {/* Instructor Info */}
            <div className="pt-4 border-t border-gray-100 dark:border-gray-700">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gray-50 dark:bg-gray-700 flex items-center justify-center p-1">
                  <img src={teacherIcon} alt="Teacher" className="w-10 h-10 object-contain" />
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {instructor}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-300">
                    مدرب
                  </div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-between mt-auto">
              {/* زر الشراء أو منتهية أو قريبًا */}
              {isExpired ? (
                <button
                  className="px-5 py-1.5 rounded text-sm font-medium bg-gray-500 text-white cursor-not-allowed dark:bg-gray-600 dark:text-white"
                  disabled
                >
                  منتهية
                </button>
              ) : is_coming_soon_display ? (
                <button
                  className="px-5 py-1.5 rounded text-sm font-medium bg-amber-500 text-white cursor-not-allowed"
                  disabled
                >
                  <span className="font-semibold">قريبًا </span>
                </button>
              ) : isSubscribed ? (
                <button
                  className="px-5 py-1.5 rounded text-sm font-medium bg-green-500 text-white cursor-not-allowed dark:bg-green-500 dark:text-white"
                  disabled
                >
                  مشترك بالفعل
                </button>
              ) : (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    // إضافة الدورة للسلة مباشرة
                    // تحويل السعر إلى رقم بغض النظر عن التنسيق
                    const parsePrice = (priceStr) => {
                      if (typeof priceStr === 'number') return priceStr;
                      if (!priceStr) return 0;
                      // إزالة أي حروف غير رقمية وتحويل لرقم
                      const num = parseFloat(String(priceStr).replace(/[^0-9.]/g, ''));
                      return isNaN(num) ? 0 : num;
                    };

                    const coursePrice = parsePrice(discountedPrice || price);
                    const originalPriceNum = parsePrice(originalPrice);

                    const courseForCart = {
                      id,
                      title,
                      price: coursePrice,
                      coverImage: coverImage,
                      type: 'course',
                      instructor,
                      originalPrice: originalPriceNum
                    };
                    dispatch(addToCart(courseForCart));
                    // الانتقال إلى صفحة السلة مباشرة
                    window.location.href = '/cart';
                  }}
                  className="px-5 py-1.5 rounded text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 dark:bg-blue-600 dark:text-white dark:hover:bg-blue-700"
                >
                  اشتري الآن
                </button>
              )}
              <div className="flex flex-col items-end gap-1 h-[38px] justify-end"> {/* تحديد ارتفاع ثابت */}
                {!is_coming_soon_display && (
                  discount ? (
                    <>
                      <span className="text-sm text-red-500 line-through font-bold">
                        {!originalPrice.includes('مجاني') && !originalPrice.includes('مجاناً') && <span style={{ fontFamily: 'saudi_riyal', fontSize: '1.1em' }}>&#xE900;</span>}
                        {originalPrice.includes('مجاني') ? originalPrice.replace('مجاني', 'مجاناً') : originalPrice.replace(' ريال', '')}
                      </span>
                      <span className="text-lg text-blue-500 font-bold">
                        {!discountedPrice.includes('مجاني') && !discountedPrice.includes('مجاناً') && <span style={{ fontFamily: 'saudi_riyal', fontSize: '1.2em' }}>&#xE900;</span>}
                        {discountedPrice.includes('مجاني') ? discountedPrice.replace('مجاني', 'مجاناً') : discountedPrice.replace(' ريال', '')}
                      </span>
                    </>
                  ) : (
                    <span className="text-lg text-blue-500 font-bold">
                      {!discountedPrice.includes('مجاني') && !discountedPrice.includes('مجاناً') && <span style={{ fontFamily: 'saudi_riyal', fontSize: '1.2em' }}>&#xE900;</span>}
                      {discountedPrice.includes('مجاني') ? discountedPrice.replace('مجاني', 'مجاناً') : discountedPrice.replace(' ريال', '')}
                    </span>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CourseCard;
